export const paymentsData = [
  {
    id: 1,
    invoiceId: "#1254049",
    client: "NovaWave LLC",
    amount: "$5000",
    dueDate: "28 Dec 2023",
    client_img: "assets/img/icons/company-icon-05.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID1A2B3C4D5E6",
    key: "1"
  },
  {
    id: 2,
    invoiceId: "#1254050",
    client: "Redwood Inc",
    amount: "$4180",
    dueDate: "22 Dec 2023",
    client_img: "assets/img/icons/company-icon-10.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID98765ASDF43",
    key: "2"
  },
  {
    id: 3,
    invoiceId: "#1254051",
    client: "Golden Gate Ltd",
    client_img: "assets/img/icons/company-icon-02.svg",
    amount: "$3125",
    dueDate: "14 Dec 2023",
    paymentMethod: "Credit",
    transactionId: "TXNIDQWERTY0987",
    key: "3"
  },
  {
    id: 4,
    invoiceId: "#1254052",
    client: "HarborView",
    amount: "$1230",
    dueDate: "07 Dec 2023",
    client_img: "assets/img/icons/company-icon-03.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID54321XYZ789",
    key: "4"
  },
  {
    id: 5,
    invoiceId: "#1254053",
    client: "CoastalStar Co.",
    amount: "$3500",
    dueDate: "20 Nov 2023",
    client_img: "assets/img/icons/company-icon-03.svg",
    paymentMethod: "Credit",
    transactionId: "TXNIDABCDE12345",
    key: "5"
  },
  {
    id: 6,
    invoiceId: "#1254054",
    client: "RiverStone Ventur",
    amount: "$2120",
    dueDate: "18 Nov 2023",
    client_img: "assets/img/icons/company-icon-04.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID0123456789",
    key: "6"
  },
  {
    id: 7,
    invoiceId: "#1254055",
    client: "Summit Peak",
    amount: "$4000",
    dueDate: "10 Nov 2023",
    client_img: "assets/img/icons/company-icon-03.svg",
    paymentMethod: "Credit",
    transactionId: "TXNID1357924680",
    key: "7"
  },
  {
    id: 8,
    invoiceId: "#1254056",
    client: "Silver Hawk",
    amount: "$2100",
    dueDate: "24 Oct 2023",
    client_img: "assets/img/icons/company-icon-02.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID2468135790",
    key: "8"
  },
  {
    id: 9,
    invoiceId: "#1254057",
    client: "BlueSky Industries",
    amount: "$1450",
    dueDate: "19 Oct 2023",
    client_img: "assets/img/icons/company-icon-02.svg",
    paymentMethod: "Credit",
    transactionId: "TXNID9876543210",
    key: "9"
  },
  {
    id: 10,
    invoiceId: "#1254058",
    client: "NovaWave LLC",
    amount: "$2500",
    dueDate: "15 Oct 2023",
    client_img: "assets/img/icons/company-icon-01.svg",
    paymentMethod: "Cash",
    transactionId: "TXNID1234567890",
    key: "10"
  },
];
